import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Grid } from '@mui/material';
import { pick } from 'lodash';

import { navSections, useRegisterSection } from 'components/OnePageTemplates/common';
import { useDataContext } from 'components/OnePageTemplates/context';

import { hasMeaningfulValues } from 'helpers/hasMeaningfulValues';

import { LargeCard } from '../components/LargeCard';

import styles from './BusinessIdeaSection.module.scss';

export const BusinessIdeaSection: FC = () => {
  const { data } = useDataContext();
  const { t } = useTranslation();
  const registerNavSection = useRegisterSection(navSections.businessIdea);

  const sectionData = pick(data, ['projectBriefDescription', 'problemOfMarket', 'strategyForAchievingGoals', 'team']);

  if (!hasMeaningfulValues(sectionData)) {
    return null;
  }

  const hasProblemAndSolution = hasMeaningfulValues([data.problemOfMarket, data.strategyForAchievingGoals]);
  const hasDescriptionAndTeam = hasMeaningfulValues([data.projectBriefDescription, data.team]);

  return (
    <Box {...registerNavSection} className={styles.section}>
      <Box className={styles.wrapper}>
        {hasProblemAndSolution && (
          <Box className={styles.businessIdeaSection}>
            <Box className={styles.title}>{t('business')} {t('idea')}</Box>
            <Grid container spacing={3}>
              {data.problemOfMarket && (
                <Grid item xs={12}>
                  <LargeCard
                    title={t('onePageMapping.problem')}
                    content={data.problemOfMarket}
                    variant="transparent"
                    className={styles.card}
                  />
                </Grid>
              )}
              {data.strategyForAchievingGoals && (
                <Grid item xs={12}>
                  <LargeCard
                    title={t('onePageMapping.solution')}
                    content={data.strategyForAchievingGoals}
                    variant="transparent"
                    className={styles.card}
                  />
                </Grid>
              )}
            </Grid>
          </Box>
        )}
        {hasDescriptionAndTeam && (
          <Box className={styles.container}>
            <Grid style={{ marginTop: -16 }} container spacing={3}>
              {data.projectBriefDescription && (
                <Grid item xs={12} style={{ paddingTop: 0 }}>
                  <LargeCard
                    title={t('onePageMapping.projectDescription')}
                    content={data.projectBriefDescription}
                    variant="transparent"
                    className={styles.whiteCard}
                  />
                </Grid>
              )}
              {data.team && (
                <Grid item xs={12}>
                  <LargeCard title={t('chapters.TEAM')} content={data.team} variant="transparent" className={styles.whiteCard} />
                </Grid>
              )}
            </Grid>
          </Box>
        )}
      </Box>
    </Box>
  );
};
